export const environment = {
  name: 'stage',
  apiUrl: 'https://stage.mib.motion.abb.com',
  authClientId: 'pmhDL2OLuIGvcxXJFDXfi608qXIa',
  authority: 'https://stage.polaris.iam.motion.abb.com/oauth2/token',
  authWellknownEndpointUrl: 'https://stage.api.accessmanagement.motion.abb.com/polaris/oidc/.well-known/openid-configuration',
  authRedirectUrl: 'https://stage.mib.motion.abb.com/ui/callback',
  authLogoutUrl: 'https://stage.mib.motion.abb.com/ui/logout',
  appInsightsConnString: 'fill after initial stage deploy'
};
